import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { PopupFooter } from '@gem/ui-kit';

import { ForwardMessageFooterView } from 'APP/main/PopupManager/components/ForwardMessageFooterView/ForwardMessageFooterView';
import { ShareDataView } from 'APP/main/PopupManager/components/ShareDataView/ShareDataView';

import {
  IForwardMessagePopupParams,
  useForwardMessagePresenter,
} from './ForwardMessagePopup.presenter';
import styles from './ForwardMessagePopup.styles.m.css';

export const ForwardMessagePopup: FC<ICommonPopupsProps<IForwardMessagePopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useForwardMessagePresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened={presenter.isAvailableToShow}
        title={t('forward_screen_title')}
        onClose={presenter.onClose}
      >
        <ShareDataView
          multiselect
          onSelectItem={presenter.onSelectItem}
          onChangeSelection={presenter.onChangeSelection}
        />
        <PopupFooter
          className={classNames(styles.forwardMessageFooter, {
            [styles.withInput]: !!presenter.selection.length,
          })}
        >
          <ForwardMessageFooterView
            selection={presenter.selection}
            isDisabled={!presenter.hasSelected}
            isLoading={presenter.isSubmitting}
            onSubmit={presenter.submit}
          />
        </PopupFooter>
      </Popup>
    );
  }
);
